import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import MainNavComponent from './js/main-nav.component';

ComponentsFactory.getInstance().define('main-nav', MainNavComponent);
